export default "__VITE_ASSET__BQdXSIld__"